<soft-page>
  <soft-page-header>
    <div>
      <p class="soft-title">{{ headerTitle }}</p>
      <p class="text-sm text-light">{{ headerSubtitle }}</p>
    </div>
  </soft-page-header>
  <form class="mt-3" [formGroup]="form">
    <div class="flex-col-3">
      <div class="flex justify-between items-start py-3">
        <div class="w-[100%]">
          <label class="soft-label top block mb-2" for="name">Name</label>
          <soft-field-ok
            fieldOkName="kasse"
            placeholder="Kassa auswählen"
            formControlName="name"
          />
        </div>
      </div>
      <div class="flex justify-between items-start">
        <div class="w-[40%]">
          <label class="soft-label top block mb-2" for="paymentMethod">Zahlungsart</label>
          <soft-field-ok
            fieldOkName="zahlartkassa"
            placeholder="Standard Zahlungsart auswählen"
            formControlName="paymentMethod"
          />
        </div>

        <div class="w-[40%]">
          <label class="soft-label top block mb-2" for="paymentMethodMinus"
            >Zahlungsart Minus</label
          >
          <soft-field-ok
            fieldOkName="zahlartkassa"
            formControlName="paymentMethodMinus"
            placeholder="Standard Zahlungsart für Retour auswählen"
          />
        </div>

        <div class="w-[10%] items-center px-3">
          <label class="soft-label top block mb-1" for="autologin">Auto Login</label>
          <soft-toggle-switch
            class="w-full items-center p-2"
            formControlName="autologin"
          />
        </div>
      </div>

      <div class="flex flex-col mt-2">
        <div class="grid grid-cols-2 gap-2">
          <div class="flex flex-col">
            <span class="soft-overline">Vorgeschlagene Positionsrabatte</span>
            <ul class="flex flex-col gap-2">
              @for (discount of discountsConfig()?.discountValues; track $index) {
                <li class="soft-card flex items-center justify-between">
                  <span [class.required]="discount.saved === false">
                    {{ discount.value | format:'NUMBER.DEFAULT' }}%
                  </span>

                  @if (discount.source === 'remote') {
                    <soft-icon name="fa-regular fa-cloud-arrow-down" />
                  } @else if (discount.saved === false) {
                    <soft-icon name="fa-regular rotate-exclamation text-warning" />
                  }
                </li>
              }

              <button
                type="button"
                class="border-2 border-dotted rounded border-primary/30 hover:border-primary p-2 font-semibold flex items-center gap-2 justify-center"
                (click)="addDiscountValue('item')"
              >
                <soft-icon name="fa-solid fa-plus-circle text-primary" />
                Erstellen
              </button>
            </ul>
          </div>

          <div class="flex flex-col">
            <span class="soft-overline">Vorgeschlagene Belegrabatte</span>
            <ul class="flex flex-col gap-2">
              @for (discount of discountsConfig()?.generalDiscountValues; track $index) {
                <li class="soft-card">
                  {{ discount.value | format:'NUMBER.DEFAULT' }}%
                </li>
              }

              <button
                type="button"
                class="border-2 border-dotted rounded border-primary/30 hover:border-primary p-2 font-semibold flex items-center gap-2 justify-center"
                (click)="addDiscountValue('document')"
              >
                <soft-icon name="fa-solid fa-plus-circle text-primary" />
                Erstellen
              </button>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>

  @if (moduleProperties().length > 0) {
    <div class="mt-6">
      <p class="soft-label top block mb-2">Eigenschaften</p>
      <ul class="flex flex-col divide-y border rounded">
        @for (property of moduleProperties(); track property.key) {
          <li class="flex items-center justify-between px-3 py-2">
            <span class="text-sm">{{ property.key }}</span>
            @if (property.isBoolean) {
              <soft-ds-switch
                [value]="property.checked"
                (valueChange)="togglePropertyOverride(property.key, $event)"
              />
            } @else {
              <span class="text-sm font-semibold">{{ property.value }}</span>
            }
          </li>
        }
      </ul>
    </div>
  }

  <div class="mt-6">
    <p class="soft-label top block mb-2">Anzeige (Kassa)</p>
    <ul class="flex flex-col divide-y border rounded">
      <li class="flex items-center justify-between px-3 py-2">
        <span class="text-sm">Lagerstand anzeigen</span>
        <soft-ds-switch
          [value]="overrides.showLagerstand()"
          (valueChange)="toggleShowLagerstand($event)"
        />
      </li>
      <li class="flex items-center justify-between px-3 py-2">
        <span class="text-sm">Dispostand anzeigen</span>
        <soft-ds-switch
          [value]="overrides.showDispo()"
          (valueChange)="toggleShowDispo($event)"
        />
      </li>
    </ul>
  </div>
</soft-page>
